<div class="salesforce-not-authorized">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Access not authorized</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <p>
        You are signed in with Salesforce, but your Blankmile account is not
        authorized for this tenant.
      </p>
      <p>Please contact your administrator if you need access.</p>
    </mat-card-content>
  </mat-card>
</div>
